<template>
    <div class="page-layout blank contacts-manage">
        <div class="pb-10 pr-3 pl-3">
            <!-- Breadcrumb section -->
            <div class="row">
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 d-flex justify-content-between align-items-center">
                    <div class="breadcrumbnew">
                        <span @click="$router.go(-1)">Sales Dashboard</span>
                    </div>
                    <div class="d-flex justify-content-between align-items-center">
                        <div class="dropdown-label">Period : </div>
                        <div class="dropdown perioddropdown">
                            <ul class='nav nav-tabs'>
                                <li class='nav-item dropdown'>
                                    <a aria-expanded='false' aria-haspopup='true'
                                        class='nav-link dropdown-toggle dropdown-button on-focus' data-toggle='dropdown'
                                        href='#' role='button'>
                                        <span v-if="this.period_data == 'fiscal_year'">Fiscal Year</span>
                                        <span v-if="period_data == 'h1'">Semi Annual H1</span>
                                        <span v-if="period_data == 'h2'">Semi Annual H2</span>
                                        <span v-if="period_data == 'q1'">Quarter Q1</span>
                                        <span v-if="period_data == 'q2'">Quarter Q2</span>
                                        <span v-if="period_data == 'q3'">Quarter Q3</span>
                                        <span v-if="period_data == 'q4'">Quarter Q4</span>
                                        <span v-if="this.period_data == 'month'">Month</span>
                                    </a>
                                    <div class='dropdown-menu period-dropdown-menu'>
                                        <a @click="getData('fiscal_year')" class='dropdown-item' href='#'>Fiscal
                                            Year</a>
                                        <div class='dropdown-item dropdown-submenu period-dropdown'>
                                            <a class='dropdown-item dropdown-item-toggle' data-toggle='dropdown'
                                                href='#'>Semi-Annual</a>
                                            <div class='dropdown-menu period-dropdown-menu sub-dropdown'>
                                                <a @click="getData('h1')" class='dropdown-item' href='#'>H1</a>
                                                <a @click="getData('h2')" class='dropdown-item' href='#'>H2</a>
                                            </div>
                                        </div>
                                        <div class='dropdown-item dropdown-submenu period-dropdown'>
                                            <a class='dropdown-item dropdown-item-toggle' data-toggle='dropdown'
                                                href='#'>Quarter</a>
                                            <div class='dropdown-menu period-dropdown-menu sub-dropdown'>
                                                <a @click="getData('q1')" class='dropdown-item' href='#'>Q1</a>
                                                <a @click="getData('q2')" class='dropdown-item' href='#'>Q2</a>
                                                <a @click="getData('q3')" class='dropdown-item' href='#'>Q3</a>
                                                <a @click="getData('q4')" class='dropdown-item' href='#'>Q4</a>
                                            </div>
                                        </div>
                                        <a @click="getData('month')" class='dropdown-item' href='#'>Month</a>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div class="d-flex align-items-center justify-content-center h-100" v-if="ajaxCallInProgress">
                <half-circle-spinner :animation-duration="1000" :size="60" color="#00448b" style="margin: 0 auto;" />
            </div>
            <div v-else-if="!ajaxCallInProgress">
                <div class="row">
                    <!-- Leads section -->
                    <div class="col-lg-3 col-sm-12 col-md-3 p-0 pl-4 mt-2 pr-1">
                        <fullscreen ref="leadsCustom" @change="dataChange('leadsCustom')" class="box-radius bg-white">
                            <div class="card-item-contact bg-white text-auto">
                                <div class="d-flex justify-content-between aline-items-center">
                                    <div class="fw-600 fs-14">Leads</div>
                                    <button type="button" class="pointer bg-white icon-outline-css"
                                        @click="expandData('leads'), addDataClass()">
                                        <img class="expand-img" src="/static/images/exapand.svg" alt />
                                    </button>
                                </div>
                                <div class="d-flex align-items-center justify-content-center"
                                    v-if="loadLeadsSection" style="height: 212px;">
                                    <half-circle-spinner :animation-duration="1000" :size="60" color="#00448b"
                                        style="margin: 0 auto;" />
                                </div>
                                <div v-else class="row">
                                    <div class="col-lg-12 col-md-12 col-sm-12">
                                        <div id="leadsDiv" class="mt-3"></div>
                                    </div>
                                </div>
                            </div>
                        </fullscreen>
                    </div>
                    <!-- Deals section -->
                    <div class="col-lg-3 col-sm-12 col-md-3 p-0 pl-2 mt-2 pr-1">
                        <fullscreen ref="dealsCustom" @change="dataChange('dealsCustom')" class="box-radius bg-white">
                            <div class="card-item-contact bg-white text-auto">
                                <div class="d-flex justify-content-between aline-items-center">
                                    <div class="fw-600 fs-14">Deals</div>
                                    <button type="button" class="pointer bg-white icon-outline-css"
                                        @click="expandData('deals'), addDataClass()">
                                        <img class="expand-img" src="/static/images/exapand.svg" alt />
                                    </button>
                                </div>
                                <div class="d-flex align-items-center justify-content-center"
                                    v-if="loadDealsSection" style="height: 212px;">
                                    <half-circle-spinner :animation-duration="1000" :size="60" color="#00448b"
                                        style="margin: 0 auto;" />
                                </div>
                                <div v-else class="row">
                                    <div class="col-lg-12 col-md-12 col-sm-12">
                                        <div id="dealsDiv" class="mt-3"></div>
                                    </div>
                                </div>
                            </div>
                        </fullscreen>
                    </div>
                    <!-- Customer distribution section -->
                    <div class="col-lg-3 col-sm-6 col-md-3 p-0 pl-2 mt-2 pr-1">
                        <fullscreen ref="territoryCustom" @change="dataChange('territoryCustom'), addDataClass()"
                            class="box-radius bg-white">
                            <div class="card-item-contact bg-white text-auto">
                                <div class="d-flex justify-content-between aline-items-center">
                                    <div class="fw-600 fs-14">Customer Distribution</div>
                                    <button type="button" class="pointer bg-white icon-outline-css"
                                        @click="expandData('territory')">
                                        <img class="expand-img" src="/static/images/exapand.svg" alt />
                                    </button>
                                </div>
                                <div class="d-flex align-items-center justify-content-center"
                                    v-if="loaddistributionSection" style="height: 212px;">
                                    <half-circle-spinner :animation-duration="1000" :size="60" color="#00448b"
                                        style="margin: 0 auto;" />
                                </div>
                                <div v-else class="row">
                                    <div class="col-lg-12 col-md-12 col-sm-12">
                                        <div id="territoryDiv" class="mt-3"></div>
                                    </div>
                                </div>
                            </div>
                        </fullscreen>
                    </div>
                    <!-- Contact Media section -->
                    <div class="col-lg-3 col-sm-6 col-md-3 p-0 pr-4 pl-2 mt-2 pr-1">
                        <fullscreen ref="mediaCustom" @change="dataChange('mediaCustom')" class="box-radius bg-white">
                            <div class="card-item-contact bg-white text-auto contactMedia">
                                <div class="d-flex justify-content-between aline-items-center">
                                    <div class="fw-600 fs-14">Contact Media<br>
                                        <div v-if="!loadContactMediaSection && count != 0">
                                            <span><img width="14px" height="14px"
                                                    src="/static/images/images-new-theme/icons/symbol.svg"></span>
                                            <span class="mt-2 px-2">{{count}}</span>
                                            <span class=" mt-2 px-2 ml-4"
                                                :class="{'icon_div':percent < 0,'icon_div_green':percent >= 0 }"><img
                                                    width="10px" height="10px" class="mr-1"
                                                    :class="{'red-div':percent < 0,'green-div':percent >= 0 }">{{percent}}%</span>
                                        </div>
                                    </div>
                                    <button type="button" class="pointer bg-white icon-outline-css"
                                        @click="expandData('media'), addDataClass()">
                                        <img class="expand-img" src="/static/images/exapand.svg" alt />
                                    </button>
                                </div>
                                <div class="row">
                                    <div class="col-lg-12 col-md-12 col-sm-12 ">
                                        <div class="w-100" v-if="loadContactMediaSection">
                                                <div class="d-flex align-items-center justify-content-center w-100"
                                                    v-if="loadContactMediaSection" style="height: 212px;">
                                                    <half-circle-spinner :animation-duration="1000" :size="60"
                                                        color="#00448b" style="margin: 0 auto;" />
                                                </div>
                                        </div>
                                        <div v-else-if="!loadContactMediaSection && count == 0" class="text-center mt-3">
                                            <img src="/static/images/leads.png"
                                                class="mb-3 data-text media_contact_css" />
                                            <div class="text-center text-muted fw-500 mt-3">No media contacts added!</div>
                                        </div>
                                        <div v-else class="row">
                                            <div class="col-lg-6 col-md-6 col-sm-6 div-spacing">
                                                <div class="mt-4 box-radius mediaDiv p-1">
                                                    <div class="mt-4" v-for="(referral, index) in referral"
                                                        :key="index">
                                                        <span><img width="13px" height="13px"
                                                                :src="referral.icon"></span>
                                                        <span class=" p-1 mt-1">{{referral.count}}</span>
                                                        <span class="p-1 mt-1"
                                                            :class="{'icon_div':referral.percent < 0,'icon_div_green':referral.percent >= 0 }">
                                                            <img width="9px" height="9px" class="mr-1"
                                                                :class="{'red-div':referral.percent < 0,'green-div':referral.percent >= 0 }">{{referral.percent.toFixed(1)}}%
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-lg-6 col-md-6 col-sm-6 div-spacing">
                                                <div class="mt-4 box-radius mediaDiv p-1">
                                                    <div class="mt-4" v-for="(social, index) in contact_media"
                                                        :key="index">
                                                        <span><img width="14px" height="14px" :src="social.icon"></span>
                                                        <span class=" p-1 mt-1">{{social.count}}</span>
                                                        <span class=" p-1 mt-1 "
                                                            :class="{'icon_div':social.percent < 0,'icon_div_green':social.percent >= 0 }">
                                                            <img width="9px" height="9px" class="mr-1"
                                                                :class="{'red-div':social.percent < 0,'green-div':social.percent >= 0 }">{{social.percent.toFixed(1)}}%
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </fullscreen>
                    </div>

                </div>
                <div class="row">
                    <!-- Campaign Info based on Budget section -->
                    <div class="col-lg-5 col-md-5 col-sm-12 p-0 pl-4 mt-3">
                        <!-- <div class="card-item bg-white text-auto pb-0">
                            <div class="d-flex justify-content-between aline-items-center">
                                <div class="fw-600">Campaign</div>
                                <button type="button" class="pointer bg-white">
                                    <img class="expand-img" src="/static/images/exapand.svg" alt />
                                </button>
                            </div>
                            <div class="row">
                                <div class="col-lg-12">
                                    <div id="campaignDiv" class="mt-3"></div>
                                </div>
                            </div>
                        </div> -->
                        <fullscreen class="box-radius bg-white" ref="campaignCustom" @change="dataChange('campaign')">
                            <div class="p-3">
                                <div class="d-flex justify-content-between aline-items-center mt-1">
                                    <div class="fw-600 fs-14">Campaign Info based on Budget</div>
                                    <div class="d-flex">
                                        <span class="fs-14 fw-600">
                                            Total Budget: <span style="color: #003e96;">{{ currency }} {{total_budget}}</span>
                                        </span>
                                        <button type="button" class="pointer bg-white icon-outline-css"
                                            @click="expandData('campaign'), addDataClass()">
                                            <img class="expand-img" src="/static/images/exapand.svg" alt />
                                        </button>
                                    </div>
                                </div>
                                <div v-if="dateRange.length" style="border-bottom: 1px solid #a9aaad;">
                                    <div class="d-flex justify-content-between align-items-center"
                                        style="background: #41b883; border-radius: 12px; padding-left: 10px; padding-right: 10px; margin-top: 4px; margin-bottom: 8px; width: 16em;">
                                        <input type="text"
                                            :value="('0'+new Date(dateRange[0]).getDate()).slice(-2)+'/'+('0'+(new Date(dateRange[0]).getMonth()+1)).slice(-2)+'/'+new Date(dateRange[0]).getFullYear()+' to '+('0'+new Date(dateRange[1]).getDate()).slice(-2)+'/'+('0'+(new Date(dateRange[1]).getMonth()+1)).slice(-2)+'/'+new Date(dateRange[1]).getFullYear()"
                                            style="color: #fff; background: #41b883; width: 14em;" disabled />
                                        <span @click="dataClose(),dateRange= []"
                                            style="color: #fff; cursor: pointer;">&#10005;</span>
                                    </div>
                                </div>
                                <date-picker v-else @change="updatecreationDate()" v-model="dateRange"
                                    format="DD/MM/YYYY" range
                                    class="date-width calendar-edit-per callreport-listdate calendar-height-top"
                                    :show-second="false" :lang="lang" :clearable="true" confirm :not-after="new Date()"
                                    confirm-text="APPLY" type="date">
                                </date-picker>
                            </div>
                            <div class="card-item bg-white text-auto pb-0">
                                <div class="d-flex align-items-center justify-content-center"
                                    v-if="loadCampaignInfoSection" style="height: 288px;">
                                    <half-circle-spinner :animation-duration="1000" :size="60" color="#00448b"
                                        style="margin: 0 auto;" />
                                </div>
                                <div v-else class="row">
                                    <div class="col-lg-12">
                                        <div id="campaignsDiv" class="mt-3 campaignDiv"></div>
                                    </div>
                                </div>
                            </div>
                        </fullscreen>
                    </div>
                    <!-- Contracts section -->
                    <div class="col-lg-7 col-md-7 col-sm-12 p-0 pr-4 pl-3 mt-3">
                        <div class="card-item bg-white text-auto pb-0 pl-5">
                            <div class="d-flex justify-content-between aline-items-center">
                                <div class="fw-600 fs-14">Contracts</div>
                                <button type="button" class="pointer bg-white">
                                    <img class="expand-img" src="/static/images/exapand.svg" alt />
                                </button>
                            </div>
                            <div class="d-flex align-items-center justify-content-center"
                                v-if="loadContractSection" style="height: 350px;">
                                <half-circle-spinner :animation-duration="1000" :size="60" color="#00448b"
                                    style="margin: 0 auto;" />
                            </div>
                            <div v-else class="row">
                                <div class="col-lg-12">
                                    <div id="contractDiv" class="mt-3"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <!-- Target Achieved section -->
                    <div class="col-lg-5 col-md-5 col-sm-12 p-0 pl-4 mt-3">
                        <fullscreen ref="targetCustom" @change="dataChange('targetCustom')" class="box-radius bg-white">
                            <div class="card-item-contact bg-white text-auto pb-0">
                                <div class="d-flex justify-content-between aline-items-center">
                                    <div class="fw-600 fs-14">Target Achieved</div>
                                    <button type="button" class="pointer bg-white icon-outline-css"
                                        @click="expandData('target'), addDataClass()">
                                        <img class="expand-img" src="/static/images/exapand.svg" alt />
                                    </button>
                                </div>
                                <div class="d-flex align-items-center justify-content-center" v-if="loadTargetAchievedSection" style="height: 418px;">
                                    <half-circle-spinner :animation-duration="1000" :size="60" color="#00448b" style="margin: 0 auto;" />
                                </div>
                                <div v-else class="row">
                                    <div class="col-lg-12 col-md-12 col-sm-12">
                                        <div id="targetDiv" class="mt-3"></div>
                                    </div>
                                </div>
                            </div>
                        </fullscreen>
                    </div>
                    <!-- Shedule Meetings section -->
                    <div class="col-lg-7 col-md-7 col-sm-12 p-0 pl-3 pr-4 mt-3">
                        <fullscreen ref="dateCustom" @change="dataChange('dateCustom')"
                            class="box-radius bg-white disableButtons">
                            <div class="card-item bg-white text-auto pb-0 today-meetings pl-6">
                                <div class="d-flex justify-content-between align-items-center mb-3">
                                    <div class="fw-600 fs-14">Today's Schedule Meeting with Customers</div>
                                    <div class="d-flex" :class="{ 'not-allow-state' : show}">
                                        <div :class="{ 'disable-state' : show}">
                                            <div class="dropdown text-capitalize">
                                                <button class="btn btn-light btn-lg btnLight dropdown-toggle" href="#"
                                                    role="button" id="dropdownMenuLink" data-toggle="dropdown"
                                                    aria-haspopup="true" aria-expanded="false">
                                                    {{ selected_type }}
                                                </button>
                                                <div class="dropdown-menu cust-dropdown-menu"
                                                    aria-labelledby="dropdownMenuLink">
                                                    <a class="dropdown-item"
                                                        v-for="(category, index) in selected_type_options" :key="index"
                                                        v-on:click="changeCycle(category)">{{ category }}</a>
                                                </div>
                                            </div>
                                        </div>
                                        <button type="button" class="pointer bg-white icon-outline-css ml-4"
                                            @click="expandData('date'), addDataClass()">
                                            <img class="expand-img" src="/static/images/exapand.svg" alt />
                                        </button>
                                    </div>
                                </div>
                                <div class="d-flex align-items-center justify-content-center card-div-height"
                                    v-if="ajaxCallInProgressScheduleMeetings">
                                    <half-circle-spinner :animation-duration="1000" :size="60" color="#00448b"
                                        style="margin: 0 auto;" />
                                </div>
                                <div v-else>
                                    <div v-if="selected_type == 'month'" class="meeting-calendar calendar-col-height">
                                        <v-calendar is-expanded :attributes='attributes' @update:from-page="changeMonth"
                                            :from-page.sync="myFromPage">
                                            <template #day-popover="{ dayTitle, attributes }">
                                                <div>
                                                    <div
                                                        class="text-xs text-gray-300 font-semibold text-center custom-month-title">
                                                        {{ dayTitle }}
                                                    </div>
                                                    <popover-row class="custom-indicator" v-for="attr in attributes"
                                                        :key="attr.key" :attribute="attr">
                                                        <div>
                                                            <div v-for="(desData, key_desData) in attr.customData.description"
                                                                :key="key_desData">
                                                                {{ key_desData + 1 +". " }}{{ desData }}
                                                            </div>
                                                        </div>
                                                    </popover-row>
                                                </div>
                                            </template>
                                        </v-calendar>
                                    </div>
                                    <div v-if="!show">
                                        <div class="row" v-if="!open && (selected_type == 'today' || selected_type == 'tomorrow' || selected_type == 'week')">
                                            <div v-if="meeting_data.length == 0"
                                                class="text-center cust-full-screen ml-16">
                                                <div colspan="15">
                                                    <img src="/static/images/no_scheduled_meeting.png"
                                                        class="mb-3 sales-list pt-15"
                                                        style="width:40% !important; height:50% !important;" />
                                                    <div class="text-center text-muted fw-500">No scheduled meetings!</div>
                                                </div>
                                            </div>
                                            <div v-else class="col-lg-4 col-sm-6 col-md-12 mb-3 call-sch"
                                                v-for="(meeting, index) in meeting_data" :key="index"
                                                :class="{ 'not-allow-state' : is_click_true}">
                                                <div class="widget widget2 meetings pl-3 py-3">
                                                    <div class="d-flex justify-content-between align-items-center">
                                                        <div class="d-flex cards-text" v-if="meeting.type!='meeting'">
                                                            <div class="team-image team-image-completed mb-2 mr-2 bg-green"
                                                                v-if="meeting.status == 'completed' || meeting.status == 'complete'">
                                                                <span style="text-transform: uppercase;">{{ "D" }}</span>
                                                            </div>
                                                            <div class="team-image mb-2 mr-2" v-else>
                                                                <span
                                                                    style="text-transform: uppercase;">{{ "P" }}</span>
                                                            </div>
                                                            <p class="text-name-ellipsis text-left call-sch fw-600 text-blue"
                                                                :title="meeting.title" v-on:click="display(meeting)"
                                                                v-bind:class="{'disable-state' : is_click_true}">
                                                                {{meeting.title}}</p>
                                                        </div>
                                                        <div v-else>
                                                            <p class="text-name-ellipsis text-left call-sch fw-600 text-blue text-capitalize"
                                                                :title="meeting.title" v-on:click="display(meeting)"
                                                                v-bind:class="{'disable-state' : is_click_true}">
                                                                {{meeting.title}}</p>
                                                        </div>
                                                        <div class="text-right" v-if="meeting.is_mark_complete">
                                                            <el-dropdown trigger="click" class="mb-2">
                                                                <i class="icon icon-dots-vertical fs-20 mr-2 text-black"
                                                                    style="color:#000" />
                                                                <el-dropdown-menu slot="dropdown" class="mb-2">
                                                                    <el-dropdown-item v-if="meeting.is_mark_complete"
                                                                        @click.native="markSchedule(meeting,'completed')"
                                                                        class="text-flw-up font-italic fw-600">Mark as
                                                                        Complete</el-dropdown-item>
                                                                    <!--<el-dropdown-item v-if="meeting.is_mark_pending" @click.native="markSchedule(meeting,'pending')" class="text-sch-meet font-italic fw-600">Pending</el-dropdown-item>
                                                                        <el-dropdown-item @click.native="deleteSchedule" class="text-black">Delete</el-dropdown-item>-->
                                                                </el-dropdown-menu>
                                                            </el-dropdown>
                                                        </div>
                                                    </div>
                                                    <div class="d-flex justify-content-between align-items-center">
                                                        <p><span v-if="selected_type == 'week'">{{meeting.meeting_start_date}}<br></span>{{meeting.meeting_start_time}}</p>
                                                        <span
                                                            class="mr-4 fs-14 fw-600 text-meeting font-italic">Meeting</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="bg-white text-auto pb-5 card-div-height" v-else>
                                        <div class="call-details p-6 mb-4">
                                            <div class="d-flex justify-content-between align-items-center">
                                                <div class="d-flex" style="max-width: 400px;">
                                                    <span class="team-image type-meeting mx-2 mt-1"></span>
                                                    <p class="fw-600 text-capitalize title-name">
                                                        {{meeting_details.name || meeting_details.title}}</p>
                                                </div>
                                                <div class="d-flex">
                                                    <span v-if="this.userPermissions.customers.permitted_actions.edit"
                                                        class="pointer btnpointer"
                                                        @click="editMeeting(meeting_details.id)"><img
                                                            class="icon-images pointer"
                                                            src="/static/images/dashboard/edit_icon.svg" alt=""></span>
                                                    <span v-if="this.userPermissions.customers.permitted_actions.delete"
                                                        class="pointer btnpointer" @click="deleteMeeting()"><img
                                                            class="icon-images pointer"
                                                            src="/static/images/dashboard/delete_icon.svg"
                                                            alt=""></span>
                                                    <span class="pointer" @click="show=false"><img
                                                            class="icon-images pointer"
                                                            src="/static/images/dashboard/cross_button.svg"
                                                            alt=""></span>
                                                </div>
                                            </div>
                                            <span
                                                v-if="meeting_details.start_date && meeting_details.start_time_meredian || meeting_details.start_date && !meeting_details.start_time_meredian || !meeting_details.start_date && meeting_details.start_time_meredian">{{meeting_details.start_date}}
                                                - {{meeting_details.start_time_meredian}}</span>
                                            <div class="row mt-3">
                                                <div v-if="meeting_details.products" class="col-lg-12 col-sm-12 col-md-12">
                                                    <div class="text-css mt-3">
                                                        <div class="fw-600">Product Name</div>
                                                        <div class=" mt-2 invitee-details secondary-email-list"
                                                            v-if="meeting_details.products">
                                                            <span v-for="(product, index) in meeting_details.products"
                                                                :key="index"
                                                                class="secondary-email">{{product.name}}</span>
                                                        </div>
                                                        <div class="mt-2" v-else>
                                                            <p>{{"-"}}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-lg-12 col-sm-12 col-md-12">
                                                    <div v-if="meeting_details.invitees" class="text-css mt-3">
                                                        <div class="fw-600">Invitees</div>
                                                        <div class="invitee-details secondary-email-list mt-2">
                                                            <p v-for="(invite,index) in meeting_details.invitees"
                                                                :key="index" class="secondary-email">{{invite.email}}</p>
                                                        </div>
                                                    </div>
                                                    <div v-else-if="meeting_details.invite_email">
                                                        <div class="fw-600"
                                                            v-if="meeting_details.invite_email.length == 1">
                                                            {{meeting_details.invite_email.length}} Guest</div>
                                                        <div class="fw-600" v-else>
                                                            {{meeting_details.invite_email.length}} Guests</div>
                                                        <div class="invitee-details secondary-email-list mt-2">
                                                            <p v-for="(invite,index) in meeting_details.invite_email"
                                                                :key="index" class="secondary-email">{{invite}}</p>
                                                        </div>
                                                    </div>
                                                    <div v-else>
                                                        <div class="fw-600">No Guests</div>
                                                    </div>
                                                </div>
                                                <div class="col-lg-6 col-sm-6 col-md-12">
                                                    <div class="text-css mt-3">
                                                        <div class="fw-600">Description</div>
                                                        <div class="mt-2 desc-details"
                                                            v-if="meeting_details.description">
                                                            {{meeting_details.description}}</div>
                                                        <div class="mt-2" v-else>
                                                            <p>{{"-"}}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-lg-6 col-sm-6 col-md-12">
                                                    <div class="align-items-center text-css mt-3">
                                                        <div class="fw-600">Agenda of the meeting</div>
                                                        <div class="desc-details mt-2" v-if="meeting_details.agenda">
                                                            <p>{{meeting_details.agenda}}</p>
                                                        </div>
                                                        <div class="desc-details mt-2" v-else>
                                                            <p>{{"-"}}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-lg-6 col-sm-6 col-md-12">
                                                    <div class="text-css mt-3">
                                                        <div class="fw-600">Location</div>
                                                        <div class="desc-details mt-2" v-if="meeting_details.location">
                                                            <p>{{meeting_details.location}}</p>
                                                        </div>
                                                        <div class="desc-details mt-2" v-else>
                                                            <p>{{"-"}}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-lg-6 col-sm-6 col-md-12">
                                                    <div class="text-css">
                                                        <div class="mt-9"
                                                            v-if="userPermissions.call_reports.permitted_actions.create">
                                                            <div class="dropdown text-capitalize">
                                                                <button class="btn btn-done btn-wide dropdown-toggle" href="#"
                                                                    role="button" id="dropdownMenuLink" data-toggle="dropdown"
                                                                    aria-haspopup="true" aria-expanded="false">
                                                                    + Create Call Report
                                                                </button>
                                                                <div class="dropdown-menu cust-dropdown-menu"
                                                                    aria-labelledby="dropdownMenuLink">
                                                                    <a class="dropdown-item"
                                                                        v-for="(category, index) in call_report_category_options" :key="index"
                                                                        v-on:click="addCallReport(meeting_details,category)">{{ category }}</a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </fullscreen>
                    </div>
                </div>
                <div class="row">
                    <!-- Sales Forecast Section -->
                    <div class="col-lg-3 col-sm-12 col-md-3 p-0 pl-4 mt-3">
                        <fullscreen ref="forecastCustom" @change="dataChange('forecastCustom')"
                            class="box-radius bg-white">
                            <div class="card-item-contact bg-white text-auto pb-0">
                                <div class="d-flex justify-content-between aline-items-center">
                                    <div></div>
                                    <div class="fw-600 fs-14">Sales Forecast</div>
                                    <div class="mx-2">
                                        <el-select v-model="forecast_period" @change="forecastChange()"
                                            style="border-radius: 6px;border: 0.6px solid #d7dae2 !important;"
                                            placeholder="" :popper-append-to-body="false">
                                            <el-option v-for="(time, index) in forecast_options" :key="index"
                                                :label="time" :value="time">
                                            </el-option>
                                        </el-select>
                                    </div>
                                    <button type="button" class="pointer bg-white icon-outline-css"
                                        @click="expandData('forecast'), addDataClass()">
                                        <img class="expand-img" src="/static/images/exapand.svg" alt />
                                    </button>
                                </div>
                                <div class="d-flex align-items-center justify-content-center" v-if="loadSalesForecastSection" style="height: 424px;">
                                    <half-circle-spinner :animation-duration="1000" :size="60" color="#00448b" style="margin: 0 auto;" />
                                </div>
                                <div v-else class="row">
                                    <div class="col-lg-12">
                                        <div id="salesForecastDiv" class="mt-3"></div>
                                    </div>
                                </div>
                            </div>
                        </fullscreen>
                    </div>
                    <!-- Over ALL Sales Forecast Section -->
                    <div class="col-lg-5 col-sm-12 col-md-6 p-0 pl-3 mt-3">
                        <fullscreen ref="overallCustom" @change="dataChange('overallCustom')"
                            class="box-radius bg-white">
                            <div class="card-item-contact bg-white text-auto pb-0">
                                <div class="d-flex justify-content-between aline-items-center">
                                    <div class="fw-600 fs-14">Overall Sales - Forecast vs Actual</div>
                                    <button type="button" class="pointer bg-white icon-outline-css"
                                        @click="expandData('overall'), addDataClass()">
                                        <img class="expand-img" src="/static/images/exapand.svg" alt />
                                    </button>
                                </div>
                                <div class="d-flex align-items-center justify-content-center" v-if="loadOverAllSalesSection" style="height: 442px;">
                                    <half-circle-spinner :animation-duration="1000" :size="60" color="#00448b" style="margin: 0 auto;" />
                                </div>
                                <div v-else class="row">
                                    <div class="col-lg-12">
                                        <div id="forecastDiv" class="mt-3"></div>
                                    </div>
                                </div>
                            </div>
                        </fullscreen>
                    </div>
                    <!-- Territory Sales Value Section -->
                    <div class="col-lg-4 col-sm-12 col-md-3 p-0 pr-3 pl-4 mt-3">
                        <fullscreen ref="salesCustom" @change="dataChange('salesCustom')" class="box-radius bg-white">
                            <div class="card-item-contact bg-white text-auto pb-0">
                                <div class="d-flex justify-content-between aline-items-center">
                                    <div class="fw-600 fs-14">Territory wise Sales Values</div>
                                    <button type="button" class="pointer bg-white icon-outline-css"
                                        @click="expandData('sales'), addDataClass()">
                                        <img class="expand-img" src="/static/images/exapand.svg" alt />
                                    </button>
                                </div>
                                <div class="row">
                                    <div class="col-lg-12">
                                        <div id="salesValue" class="mt-3">
                                            <table class="table-properties text-center w-100 head-css">
                                                <thead class="bg-blue" v-if="territory_data.length != 0">
                                                    <tr>
                                                        <th>Territory</th>
                                                        <th>Forecast Sales({{currency}})</th>
                                                        <th>Actual Sales({{currency}})</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr class="w-100"
                                                        v-if="loadTerritorySalesSection">
                                                        <td colspan="15">
                                                            <div class="d-flex align-items-center justify-content-center w-100"
                                                                v-if="loadTerritorySalesSection">
                                                                <half-circle-spinner :animation-duration="1000"
                                                                    :size="50" color="#00448b"
                                                                    style="margin: 0 auto;" />
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr v-if="!loadTerritorySalesSection && territory_data.length == 0"
                                                        class="text-center font-weight-bold">
                                                        <td colspan="15" calss="text-center" style="height:280px;">
                                                            <img src="/static/images/territory-sales.png"
                                                                class="mb-3 data-text sales_territory_css pt-9 " />
                                                                <div class="text-center text-muted fw-500 mt-3 pb-12">No sales data!</div>
                                                        </td>
                                                    </tr>
                                                    <tr v-else-if="!loadTerritorySalesSection && territory_data.length != 0" v-for="(target_data, index) in territory_data"
                                                        :key="index">
                                                        <td class="text-ellipsis-table" :title="target_data.territory">
                                                            {{target_data.territory}}</td>
                                                        <td>{{target_data.forecast}}</td>
                                                        <td>{{target_data.actual}}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </fullscreen>
                    </div>
                </div>
            </div>
        </div>
        <sweet-modal ref="warning_modal" icon="warning">{{warning_msg}}</sweet-modal>
        <sweet-modal ref="success_modal" icon="success">{{success_msg}}</sweet-modal>
        <delete-meeting-confirmation v-if="delete_meetings" modal_name="deleteMeetings"
            @deleteMeetingConfirmation="deleteMeetingConfirmation" @cancelDelete="cancelDelete">
        </delete-meeting-confirmation>
        <customer-meetings @hideCustomerMeeting="hideCustomerMeeting" v-if="customer_meeting" :customer_id="customer_id"
            :customer_mode="customer_mode" modal_name="customer_modal" @hide-sm-on-save="hideCustomerMeeting">
        </customer-meetings>
    </div>
</template>
<script>
    import moment from 'moment';
    import dashboard from '../mixins/dashboard';
    import {
        SweetModal
    } from 'sweet-modal-vue';
    import {
        HalfCircleSpinner
    } from "epic-spinners";
    import convert from "../mixins/convert.js";
    import customers from "../mixins/customer.js";
    const DeleteMeetingConfirmation = () => import('../alertModals/DeleteMeetingConfirmation')
    const CustomerMeetings = () => import('../Customers/AddScheduleMeetings');
    import PopoverRow from 'v-calendar/lib/components/popover-row.umd.min'
    export default {
        data() {
            return {
                loadTerritorySalesSection: false,
                loadOverAllSalesSection: false,
                loadSalesForecastSection: false,
                loadTargetAchievedSection: false,
                loadLeadsSection: false,
                loadDealsSection: false,
                loaddistributionSection: false,
                loadContactMediaSection: false,
                loadCampaignInfoSection: false,
                loadContractSection: false,
                selected_calendar_month: moment(new Date().toUTCString()).format("M"),
                selected_calendar_year: moment(new Date().toUTCString()).format("YYYY"),
                call_report_category_options: [],
                myFromPage: null,
                todos: [],
                is_permission_edit: false,
                is_permission_delete: false,
                is_click_true: false,
                delete_meetings: false,
                total_budget: '',
                meeting_details: [],
                isActive: true,
                meeting_data: [],
                meeting_name: '',
                customer_id: '',
                customer_mode: '',
                customer_meeting: false,
                leads_count: '',
                deals_count: '',
                sales_count: '',
                total_count: [],
                show: false,
                chart: {},
                selected_type: "today",
                selected_type_options: ['today','tomorrow','week','month'],
                select_month: null,
                open: false,
                period_options: '',
                leads_data: [],
                territory_data: [],
                graph_scale: [],
                target_achieved: [],
                forecast_period: 'FY 2022-2023',
                forecast_options: ['FY 2017-2018', 'FY 2018-2019', 'FY 2019-2020', 'FY 2020-2021', 'FY 2021-2022',
                    'FY 2022-2023'
                ],
                warning_msg: '',
                success_msg: '',
                referral: [],
                contact_media: [],
                distribution_data: [],
                customer_data: [],
                count: '',
                percent: '',
                time_period: 'fiscal_year',
                period_data: 'fiscal_year',
                between: '',
                ajaxCallInProgress: false,
                ajaxCallInProgressScheduleMeetings: false,
                currency: '',
                revenue_generated_data: [],
                graph_scale: [],
                created_report_date: [new Date(), new Date()],
                dateRange: [],
                rangeDate: [],
                creation_date: [],
                pickerOptions: {
                    disabledDate(time) {
                        return time.getTime() > Date.now();
                    }
                },
                lang: {
                    type: "en",
                    days: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
                    months: [
                        "Jan",
                        "Feb",
                        "Mar",
                        "Apr",
                        "May",
                        "Jun",
                        "Jul",
                        "Aug",
                        "Sep",
                        "Oct",
                        "Nov",
                        "Dec"
                    ],
                    pickers: [
                        "next 7 days",
                        "next 30 days",
                        "previous 7 days",
                        "previous 30 days"
                    ],
                    placeholder: {
                        date: "Select Date",
                        dateRange: "Select Date Range"
                    },
                },
                load_meeting: false
            }
        },
        mixins: [dashboard, convert, customers],
        components: {
            SweetModal,
            HalfCircleSpinner,
            CustomerMeetings,
            DeleteMeetingConfirmation,
            PopoverRow
        },
        methods: {
            getCallReportType() {
                this.$http.get("/call_report/get_call_report_category").then(res => {
                    if (res.data.status_id == 1) {
                        res.data.response.value.forEach(x => {
                            this.call_report_category_options.push(x.name);
                        });
                    }
                });
            },
            //add call report
            /**@params = meeting, @params = category */
            addCallReport(meeting, category) {
                this.$store.commit("setCallReportCategory", category);
                localStorage.setItem("callReportCategory", category)
                localStorage.setItem('meetingDetails', JSON.stringify(meeting))
                this.$router.push("/callreport");
            },
            changeCycle(cycle) {
                this.selected_type = cycle
            },
            changeMonth(page) {
                this.selected_calendar_month = page.month;
                this.selected_calendar_year = page.year;
            },
            //show the meeting data in details
            /**@params = meeting */
            async display(data) {
                this.is_click_true = true
                this.load_meeting = true
                this.meeting_name = data.title
                let response = await this.getCustomerMeetingDetails(data.meeting_id)
                this.meeting_details = response.response
                if (response.status_id == 1) {
                    this.show = !this.show
                }
                this.load_meeting = false
                this.is_click_true = false
            },
            //Api call to get the meeting details
            async loadMeetingData() {
                this.ajaxCallInProgressScheduleMeetings = true
                let params = {
                    cycle: this.selected_type,
                    year: this.selected_calendar_year,
                    month: this.selected_calendar_month
                }
                let response = await this.getCustomerMeetingData(params)
                this.meeting_data = response.response
                this.todos = response.response
                this.ajaxCallInProgressScheduleMeetings = false
                this.show = false
            },
        //hide the customer meeting
            hideCustomerMeeting() {
                this.customer_meeting = false
                this.loadMeetingData()
            },
             //cancel the delete meeting
            cancelDelete() {
                this.delete_meetings = false
            },
            //delete the meeting based on the type of the meeting
            deleteMeeting() {
                this.delete_meetings = true
                setTimeout(() => {
                    this.$modal.show('deleteMeetings');
                }, 500);
            },
            //get the modal of confirmation before the deletion
            async deleteMeetingConfirmation() {
                let id = this.meeting_details.id;
                let response = await this.deleteMeetingDetailsById(id)
                this.success_msg = response.message
                this.$refs.success_modal.open();
                setTimeout(() => {
                    this.$refs.success_modal.close();
                    this.loadMeetingData()
                }, 2000);
            },
            //edit the meeting based on the meeting type
            /**@params = data */
            editMeeting(id) {
                this.customer_id = id
                this.customer_mode = 'edit'
                this.customer_meeting = true
                setTimeout(() => {
                    this.$modal.show('customer_modal')
                }, 1000)
            },
             //set the date and convert the date format
            dataClose() {
                let date = this.rangeDate
                let start_date = this.convertFilter(date[0])
                let end_date = this.convertFilter(date[1])
                let newValue = start_date + ',' + end_date
                newValue = newValue.split(",")
                this.created_report_date = newValue
                this.loadCampaign()
            },
            dateSettings() {
                let date = []
                var dateOffset = (24 * 60 * 60 * 1000) * (365 * 5); //5 yrs
                var newDate = this.convertFilter(new Date());
                var oldDate = new Date();
                oldDate.setTime(oldDate.getTime() - dateOffset);
                this.created_report_date = [this.convertFilter(oldDate), newDate]
                this.rangeDate = [this.convertFilter(oldDate), newDate]
            },
            //update the creation date and change the date format
            updatecreationDate() {
                if (this.dateRange) {
                    let start_date = this.convertFilter(this.dateRange[0])
                    let end_date = this.convertFilter(this.dateRange[1])
                    let newValue = start_date + ',' + end_date
                    newValue = newValue.split(",")
                    this.created_report_date = newValue
                    this.loadCampaign()
                } else {
                    this.creation_date = []
                    this.created_report_date = []
                }
                this.$forceUpdate()

            },
            //get the data from fiscal year dropdown
            /**@params = value */
            getData(value) {
                this.period_data = value
                if (value == 'h1' || value == 'h2') {
                    this.time_period = 'semi_annual'
                    this.between = value
                } else if (value == 'q1' || value == 'q2' || value == 'q3' || value == 'q4') {
                    this.time_period = 'quarter'
                    this.between = value
                } else {
                    this.time_period = value
                    this.between = ''
                }
                setTimeout(() => {
                    this.loadDealsAnalytics(),
                        this.loadTargetAchieved(),
                        this.loadOverallSalesData(),
                        this.loadTerritoryDetails(),
                        this.loadLeadDistribution(),
                        this.loadLeadsData(),
                        this.loadContactMedia(),
                        this.loadContractsData(),
                        this.loadCampaignAPIData()
                }, 500);
            },
            addDataClass() {
                var territory = document.getElementById('territoryDiv');
                territory.classList.toggle('territoryDiv-expand');
                /* var leads = document.getElementById('leadsDiv');
                leads.classList.toggle('leadsDiv-expand');
                var deals = document.getElementById('dealsDiv');
                deals.classList.toggle('dealsDiv-expand');
                var forecast = document.getElementById('forecastDiv');
                forecast.classList.toggle('forecastDiv-expand');
                var sales = document.getElementById('salesforecastDiv');
                sales.classList.toggle('salesforecastDiv-expand');
                var salesvalue = document.getElementById('salesValue');
                salesvalue.classList.toggle('salesValue-expand');*/
            },
            //expand to full screen
            /**@params = value */
            expandData(value) {
                if (value == 'leads') {
                    this.$refs["leadsCustom"].toggle();
                } else if (value == 'deals') {
                    this.$refs["dealsCustom"].toggle();
                } else if (value == 'sales') {
                    this.$refs["salesCustom"].toggle();
                } else if (value == 'target') {
                    this.$refs["targetCustom"].toggle();
                } else if (value == 'overall') {
                    this.$refs["overallCustom"].toggle();
                } else if (value == 'territory') {
                    this.$refs["territoryCustom"].toggle();
                } else if (value == 'media') {
                    this.$refs["mediaCustom"].toggle();
                } else if (value == 'date') {
                    this.$refs["dateCustom"].toggle();
                } else if (value == 'forecast') {
                    this.$refs["forecastCustom"].toggle();
                } else if (value == 'campaign') {
                    this.$refs["campaignCustom"].toggle();
                }
                // else if (value == 'date') {
                //     this.$refs["dateCustom"].toggle();
                // }
            },
            //change the data
            /**@params = value */
            dataChange(value) {
                if (value == 'leadsCustom') {
                    this.leadsCustom = value;
                } else if (value == 'dealsCustom') {
                    this.dealsCustom = value;
                } else if (value == 'salesCustom') {
                    this.salesCustom = value;
                } else if (value == 'targetCustom') {
                    this.targetCustom = value;
                } else if (value == 'overallCustom') {
                    this.overallCustom = value;
                } else if (value == 'territoryCustom') {
                    this.territoryCustom = value;
                } else if (value == 'mediaCustom') {
                    this.mediaCustom = value;
                } else if (value == 'dateCustom') {
                    this.dateCustom = value;
                } else if (value == 'forecastCustom') {
                    this.forecastCustom = value;
                } else if (value == 'campaignCustom') {
                    this.campaignCustom = value;
                }
            },
            addAnnual() {
                let brand = true

            },
            handleChange(value, type) {
                if (type === 'second') {
                    this.open = false;
                }
            },
            forecastChange() {
                this.loadForecastAnalytics()
            },
            async showMonthPicker() {
                this.open = true
            },
            //load the contact media data
            async loadContactMedia() {
                /**@params = period, @params = between */
                this.loadContactMediaSection = true;
                let params = {
                    period: this.time_period,
                    between: this.between
                }
                let response = await this.getContactMedia(params)
                this.contact_media = response.response.social_media
                this.referral = response.response.referral
                this.total_count = response.response.total
                this.count = this.total_count.count;
                this.percent = this.total_count.percent.toFixed(2);
                if (this.count == 0) {
                    setTimeout(() => {
                        var style = document.createElement('style');
                        style.type = 'text/css';
                        style.innerHTML =
                            '.dealCss {width: 130px!important;height: 100px!important;margin:auto!important;margin-top:20px !important}';
                        document.getElementsByTagName('head')[0].appendChild(style);
                        document.getElementById('dealsDiv').innerHTML =
                            "<div class=text-center><img id= deal-img src=/static/images/leads.png class=mt-3><div class='mt-4 text-muted fw-500'>No deals added!</div></div>";
                        document.getElementById('deal-img').className = 'dealCss';
                    }, 1000);
                } else {
                    this.loadContactMediaSection = false;
                    this.loadDealsData()
                }
                this.loadContactMediaSection = false;

            },
            //Api call to ge tthe forecast data
            async loadForecastAnalytics() {
                this.loadSalesForecastSection = true;
                let data = this.forecast_period.split(" ")
                let params = {
                    fiscal_year: data[1],
                }
                let response = await this.getForecastAnalyticsData(params)
                let arr = []
                arr = response.response
                this.forecast_data = arr
                delete arr['percentage_achieved'];
                delete arr['percentage_deal_lost'];
                delete arr['percentage_pipeline'];
                let result = []
                for (let x in this.forecast_data) {
                    let data = x
                    if (x == 'target_amount') {
                        x = "Total Amount"
                    }
                    if (x == 'achieved_amount') {
                        x = "Achieved Amount"
                    }
                    if (x == 'pipeline_amount') {
                        x = "Pipeline Amount"
                    }
                    if (x == 'deal_lost_amount') {
                        x = "Deal lost Amount"
                    }
                    result.push({
                        category: x,
                        value: this.forecast_data[data]
                    });

                };
                this.sales_count = [Object.values(result)[0].value];
                this.forecast_data = result
                if (this.sales_count == 0) {
                    this.loadSalesForecastSection = false;
                    setTimeout(() => {
                        var style = document.createElement('style');
                        style.type = 'text/css';
                        style.innerHTML =
                            '.salesCss {width: 130px!important;height: 100px!important;margin:auto!important;margin-top:150px !important}';
                        document.getElementsByTagName('head')[0].appendChild(style);
                        document.getElementById('salesForecastDiv').innerHTML =
                            "<div class=text-center><img id= sales-img src=/static/images/forecast.png class=mt-3><div class='mt-4 text-muted fw-500'>No sales added!</div></div>";
                        document.getElementById('sales-img').className = 'salesCss';
                    }, 1000);
                } else {
                    this.loadSalesForecastSection = false;
                    this.loadSalesForecast()
                }
                this.loadSalesForecastSection = false;
            },
            //setting the response into the sale forecast bar
            loadSalesForecast() {
                setTimeout(() => {
                    let vueThis = this
                    var chart = am4core.create("salesForecastDiv", am4charts.PieChart);
                    chart.data = vueThis.forecast_data
                    var pieSeries = chart.series.push(new am4charts.PieSeries());
                    pieSeries.dataFields.value = "value";
                    pieSeries.dataFields.category = "category";
                    pieSeries.innerRadius = am4core.percent(50);
                    pieSeries.ticks.template.disabled = true;
                    pieSeries.labels.template.disabled = true;
                    pieSeries.labels.template.align = "center";
                    pieSeries.labels.template.valign = "center";
                    var rgm = new am4core.LinearGradientModifier();
                    rgm.brightnesses.push(0, -0.4);
                    pieSeries.slices.template.fillModifier = rgm;
                    var rgm2 = new am4core.LinearGradientModifier();
                    rgm2.brightnesses.push(0, -0.4);
                    pieSeries.slices.template.strokeModifier = rgm2;
                    pieSeries.slices.template.strokeOpacity = 1;
                    pieSeries.slices.template.strokeWidth = 1;

                    var label = pieSeries.createChild(am4core.Label);;
                    label.horizontalCenter = "middle";
                    label.verticalCenter = "middle";
                    label.fontSize = 14;

                    chart.legend = new am4charts.Legend();
                    chart.legend.position = "top";
                    //chart.legend.useDefaultMarker = true;

                    var marker = chart.legend.markers.template.children.getIndex(0);
                    marker.cornerRadius(12, 12, 12, 12);
                    marker.strokeWidth = 2;
                    marker.strokeOpacity = 1;
                    marker.stroke = am4core.color("#ccc");

                    var markerTemplate = chart.legend.markers.template;
                    markerTemplate.width = 5;
                    markerTemplate.height = 4;

                    var label = pieSeries.createChild(am4core.Label);
                    label.text = vueThis.sales_count;
                    label.horizontalCenter = "middle";
                    label.verticalCenter = "middle";
                    label.fontSize = 15;

                    pieSeries.slices.template.events.on("validated", function (event) {
                        var gradient = event.target.fillModifier.gradient
                        gradient.rotation = event.target.middleAngle + 90;

                        var gradient2 = event.target.strokeModifier.gradient
                        gradient2.rotation = event.target.middleAngle + 90;
                    })
                    chart.events.on("ready", function (event) {
                        // populate our custom legend when chart renders
                        chart.customLegend = document.getElementById('legend');
                        pieSeries.dataItems.each(function (row, i) {
                            var color = chart.colors.getIndex(i);
                            var value = row.value;
                            pieSeries.dataFields.value = value;
                        });
                    });
                }, 1000);
            },
            //APi call to load the deal analytics
            async loadDealsAnalytics() {
                /**@params = period, @prams = between */
                this.loadDealsSection = true;
                let params = {
                    period: this.time_period,
                    between: this.between
                }
                let response = await this.getDealsAnalyticsData(params)
                this.deals_data = response.response
                let result = []
                for (let x in this.deals_data) {
                    let data = x
                    if (x == 'total') {
                        x = "Total Deals"
                    }
                    if (x == 'active') {
                        x = "Pipeline"
                    }
                    if (x == 'archive') {
                        x = "Archive"
                    }
                    if (x == 'closed') {
                        x = "Closed"
                    }
                    result.push({
                        category: x,
                        value: this.deals_data[data].count
                    });
                };
                this.deals_count = [Object.values(result)[0].value];
                this.deals_data = result
                if (this.deals_count == 0) {
                    this.loadDealsSection = false;
                    setTimeout(() => {
                        var style = document.createElement('style');
                        style.type = 'text/css';
                        style.innerHTML =
                            '.imgCss {width: 130px!important;margin:auto!important;margin-top:20px !important}';
                        document.getElementsByTagName('head')[0].appendChild(style);
                        document.getElementById('dealsDiv').innerHTML =
                            "<div class=text-center><img id= analysit-img src=/static/images/leads.png class=mt-3><div class='mt-4 fw-600' >No deals added</div></div>";
                        document.getElementById('analysit-img').className = 'imgCss';
                    }, 1000);
                } else {
                    this.loadDealsSection = false;
                    this.loadDealsData()
                }
                this.loadDealsSection = false;
            },
            loadContractsData() {
                this.loadContractSection = true;
                setTimeout(() => {
                    var chart = am4core.create("contractDiv", am4charts.XYChart);
                    am4core.useTheme(am4themes_animated);
                    chart.paddingRight = 40;

                    // var style = document.createElement('style');
                    // style.type = 'text/css';
                    // style.innerHTML = '.imgContractCss {width: 350px !important;margin: auto!important;}';
                    // document.getElementsByTagName('head')[0].appendChild(style);
                    // document.getElementById('contractDiv').innerHTML = "<div class=text-center><img id= convention-img src=/static/images/revenue-generate.png class=mt-3><div class='mt-4 fw-600'>No Contracts added!</div></div></div>";
                    // document.getElementById('convention-img').className = 'imgContractCss';

                    chart.data = [{
                        "date": new Date(2018, 0, 1),
                        "value": 450,
                        "value2": 362,
                        "value3": 699
                    }, {
                        "date": new Date(2018, 0, 2),
                        "value": 269,
                        "value2": 450,
                        "value3": 841
                    }, {
                        "date": new Date(2018, 0, 3),
                        "value": 700,
                        "value2": 358,
                        "value3": 699
                    }, {
                        "date": new Date(2018, 0, 4),
                        "value": 490,
                        "value2": 367,
                        "value3": 500
                    }, {
                        "date": new Date(2018, 0, 5),
                        "value": 500,
                        "value2": 485,
                        "value3": 369
                    }, {
                        "date": new Date(2018, 0, 6),
                        "value": 550,
                        "value2": 354,
                        "value3": 250
                    }, {
                        "date": new Date(2018, 0, 7),
                        "value": 420,
                        "value2": 350,
                        "value3": 600
                    }];

                    // Create axes
                    var dateAxis = chart.xAxes.push(new am4charts.DateAxis());
                    dateAxis.renderer.grid.template.location = 0;
                    dateAxis.renderer.minGridDistance = 30;

                    var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());

                    valueAxis.events.on("ready", function (ev) {
                        ev.target.min = ev.target.min;
                        ev.target.max = ev.target.max;
                    })

                    // Create axes
                    var dateAxis = chart.xAxes.push(new am4charts.DateAxis());
                    dateAxis.renderer.minGridDistance = 10;
                    dateAxis.groupData = true;
                    dateAxis.title.text = "Time"
                    dateAxis.title.fontWeight = 600;

                    var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
                    valueAxis.title.text = "Revenue($)";
                    valueAxis.title.fontWeight = 600;
                    valueAxis.numberFormatter.numberFormat = "#a";
                    //create label
                    var ylabel = valueAxis.renderer.labels.template;
                    ylabel.truncate = true;
                    ylabel.maxWidth = 80;
                    ylabel.tooltipText = "{value}";

                    // Create series
                    var series = chart.series.push(new am4charts.ColumnSeries());
                    series.dataFields.valueY = "value";
                    series.dataFields.dateX = "date";
                    series.tooltipText = "{value}"

                    // series.tooltip.pointerOrientation = "vertical";

                    chart.cursor = new am4charts.XYCursor();

                    chart.scrollbarX = new am4core.Scrollbar();

                    // Create series
                    // function createSeries(field, name) {
                    //     var series = chart.series.push(new am4charts.ColumnSeries());
                    //     series.dataFields.valueY = field;
                    //     series.dataFields.dateX = "date";
                    //     series.name = name;
                    //     series.tooltipText = "{dateX}: [b]{valueY}[/]";
                    //     series.strokeWidth = 2;

                    //     return series;
                    // }

                    // createSeries("value", "Series #1");

                    // chart.legend = new am4charts.Legend();
                    // chart.cursor = new am4charts.XYCursor();
                    // chart.scrollbarX = new am4core.Scrollbar();
                }, 500);
                this.loadContractSection = false;
            },
            loadDealsData() {
                let vueThis = this
                am4core.useTheme(am4themes_animated);
                var chart = am4core.create("dealsDiv", am4charts.PieChart);

                // Add data
                chart.data = vueThis.deals_data
                // Add and configure Series
                var pieSeries = chart.series.push(new am4charts.PieSeries());
                pieSeries.dataFields.value = "value";
                pieSeries.dataFields.category = "category";
                pieSeries.innerRadius = am4core.percent(50);
                pieSeries.ticks.template.disabled = true;
                pieSeries.labels.template.disabled = true;
                pieSeries.labels.template.fontsize = 5;

                var rgm = new am4core.LinearGradientModifier();
                rgm.brightnesses.push(0, -0.4);
                pieSeries.slices.template.fillModifier = rgm;

                var rgm2 = new am4core.LinearGradientModifier();
                rgm2.brightnesses.push(0, -0.4);

                pieSeries.slices.template.strokeModifier = rgm2;
                pieSeries.slices.template.strokeOpacity = 1;
                pieSeries.slices.template.strokeWidth = 1;

                chart.legend = new am4charts.Legend();
                chart.legend.position = "right";
                chart.legend.useDefaultMarker = true;

                var marker = chart.legend.markers.template.children.getIndex(0);
                marker.cornerRadius(12, 12, 12, 12);
                marker.strokeWidth = 2;
                marker.strokeOpacity = 1;
                marker.stroke = am4core.color("#ccc");

                var label = pieSeries.createChild(am4core.Label);
                label.text = vueThis.deals_count;
                label.horizontalCenter = "middle";
                label.verticalCenter = "middle";
                label.fontSize = 15;

                var markerTemplate = chart.legend.markers.template;
                markerTemplate.width = 5;
                markerTemplate.height = 4;

                pieSeries.slices.template.events.on("validated", function (event) {
                    var gradient = event.target.fillModifier.gradient
                    gradient.rotation = event.target.middleAngle + 90;

                    var gradient2 = event.target.strokeModifier.gradient
                    gradient2.rotation = event.target.middleAngle + 90;
                })
            },
            async loadOverallSalesData() {
                this.loadOverAllSalesSection = true;
                let params = {
                    period: this.time_period,
                    between: this.between
                }
                let response = await this.getOverallSalesData(params)
                this.overall_data = response.response.sales_data
                this.graph_scale = response.response.graph_scale
                const result = []
                const scale = []
                const map = new Map();
                for (const item of this.overall_data) {
                    result.push({
                        year: item.fiscal_year,
                        forecast: item.forecast,
                        actual: item.actual
                    });
                }
                for (const scaledata of this.graph_scale) {
                    scale.push(scaledata)
                }
                this.overall_data = result
                this.graph_scale = scale
                if (this.overall_data == '') {
                    this.loadOverAllSalesSection = false;
                    setTimeout(() => {
                        var style = document.createElement('style');
                        style.type = 'text/css';
                        style.innerHTML =
                            '.forecastCss {width: 60%!important;height: 60%!important;margin: auto!important;margin-top: 60px!important;}';
                        document.getElementsByTagName('head')[0].appendChild(style);
                        document.getElementById('forecastDiv').innerHTML =
                            "<div class=text-center><img id= overall-img src=/static/images/response.png class=mt-3><div class=mt-4 >Amount, $ (in thousands)</div></div>";
                        document.getElementById('overall-img').className = 'forecastCss';
                    }, 1000);
                } else {
                    this.loadOverAllSalesSection = false;
                    this.loadForecast()
                }
                this.loadOverAllSalesSection = false;

            },
            loadForecast() {
                setTimeout(() => {
                    let vueThis = this
                    var chart = am4core.create("forecastDiv", am4charts.XYChart);
                    // Add data
                    chart.data = vueThis.overall_data
                    // Create axes
                    var categoryAxis = chart.yAxes.push(new am4charts.CategoryAxis());
                    categoryAxis.dataFields.category = "year";
                    categoryAxis.numberFormatter.numberFormat = "#";
                    categoryAxis.renderer.inversed = true;
                    categoryAxis.renderer.grid.template.location = 0;
                    categoryAxis.renderer.cellStartLocation = 0.1;
                    categoryAxis.renderer.cellEndLocation = 0.9;
                    categoryAxis.renderer.minGridDistance = 0;
                    // categoryAxis.renderer.maxGridDistance = 30;
                    categoryAxis.title.text = "Year";
                    categoryAxis.title.fontWeight = 600;
                    var valueAxis = chart.xAxes.push(new am4charts.ValueAxis());
                    //valueAxis.renderer.minGridDistance = 30;
                    valueAxis.title.text = "Amount(" + vueThis.currency + ")in thousands";
                    valueAxis.title.fontWeight = 600;
                    chart.legend = new am4charts.Legend();
                    chart.legend.position = "bottom";
                    //chart.legend.useDefaultMarker = true;
                    // Create series
                    function createSeries(field, name) {
                        var series = chart.series.push(new am4charts.ColumnSeries());
                        series.dataFields.valueX = field;
                        series.dataFields.categoryY = "year";
                        series.name = name;
                        series.columns.template.tooltipText = "{name}: [bold]{valueX}[/]";
                        series.columns.template.height = am4core.percent(100);
                        series.sequencedInterpolation = true;
                        var valueLabel = series.bullets.push(new am4charts.LabelBullet());
                        valueLabel.label.text = "{valueX}";
                        valueLabel.label.horizontalCenter = "left";
                        valueLabel.label.dx = 10;
                        valueLabel.label.hideOversized = false;
                        valueLabel.label.truncate = false;
                        var categoryLabel = series.bullets.push(new am4charts.LabelBullet());
                        categoryLabel.label.text = "{name}";
                        categoryLabel.label.horizontalCenter = "right";
                        //categoryLabel.label.dx = -10;
                        categoryLabel.label.fill = am4core.color("#fff");
                        categoryLabel.label.hideOversized = false;
                        categoryLabel.label.truncate = false;
                    }
                    createSeries("forecast", "Forecast");
                    createSeries("actual", "Actual");
                }, 1000);
            },
            //APi call to load the target achieved
            async loadTargetAchieved() {
                this.loadTargetAchievedSection = true;
                /**@prams = period, @prams = between */
                let params = {
                    period: this.time_period,
                    between: this.between
                }
                let response = await this.getTargetSalesPerson(params)
                this.target_achieved = response.response.sales_person_achieved
                this.graph_scale = response.response.graph_scale
                const result = []
                const scale = []
                const map = new Map();
                for (const item of this.target_achieved) {
                    result.push({
                        achieved: item.achieved,
                        //assigned_to_id:item.assigned_to_id,
                        name: item.name,
                        target: item.target,
                        href: 'https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/Avatar 1.svg'
                    });
                }
                for (const scaledata of this.graph_scale) {
                    scale.push(scaledata)
                }
                this.target_achieved = result
                if (this.target_achieved == '') {
                    this.loadTargetAchievedSection = false;
                    setTimeout(() => {
                        var style = document.createElement('style');
                        style.type = 'text/css';
                        style.innerHTML =
                            '.targetCss {width: 70%!important;height: 70%!important;margin: auto!important;margin-top: 60px!important;}';
                        document.getElementsByTagName('head')[0].appendChild(style);
                        document.getElementById('targetDiv').innerHTML =
                            "<div class=text-center><img id= target-img src=/static/images/customers.png class=mt-3><div class='mt-4 text-muted fw-500'> Amount targets to be added! </div></div>";
                        document.getElementById('target-img').className = 'targetCss';
                    }, 1000);
                } else {
                    this.loadTargetAchievedSection = false;
                    this.showTargetAchieve()
                }
                this.graph_scale = scale
                this.loadTargetAchievedSection = false;
            },
            //show the response of the target achived into the chart
            showTargetAchieve() {
                setTimeout(() => {
                    let vueThis = this

                    var chart = am4core.create("targetDiv", am4charts.XYChart);
                    am4core.useTheme(am4themes_animated);
                    chart.hiddenState.properties.opacity = 0; // this creates initial fade-in
                    // chart.paddingRight = 40;
                    chart.data = vueThis.target_achieved;

                    var categoryAxis = chart.yAxes.push(new am4charts.CategoryAxis());
                    categoryAxis.dataFields.category = "name";
                    categoryAxis.renderer.grid.template.strokeOpacity = 0;
                    categoryAxis.renderer.minGridDistance = 20;
                    categoryAxis.renderer.labels.template.dx = -10;
                    categoryAxis.renderer.minWidth = 100;
                    categoryAxis.renderer.tooltip.dx = -40;
                    categoryAxis.renderer.labels.template.valign = "left";
                    categoryAxis.renderer.labels.template.fontSize = 13;
                    categoryAxis.title.text = "Sales Person";
                    categoryAxis.title.fontWeight = 600;

                    var valueAxis = chart.xAxes.push(new am4charts.ValueAxis());
                    valueAxis.renderer.inside = true;
                    valueAxis.renderer.labels.template.fillOpacity = 0.3;
                    valueAxis.renderer.grid.template.strokeOpacity = 0;
                    valueAxis.min = 0;
                    valueAxis.max = 5;
                    valueAxis.renderer.minGridDistance = 50;
                    valueAxis.title.text = "Achieved Amount (" + vueThis.currency + ")"
                    valueAxis.renderer.tooltip.dy = -20;
                    valueAxis.title.align = "left";
                    valueAxis.title.valign = "bottom";
                    valueAxis.title.fontWeight = 800;
                    valueAxis.cursorTooltipEnabled = false;
                    valueAxis.renderer.baseGrid.strokeOpacity = 0;

                    var series = chart.series.push(new am4charts.ColumnSeries);
                    series.dataFields.valueX = "target";
                    series.dataFields.categoryY = "name";

                    series.tooltip.pointerOrientation = "vertical";
                    series.tooltip.dy = -30;
                    series.columnsContainer.zIndex = 100;


                    var columnTemplate = series.columns.template;
                    columnTemplate.height = am4core.percent(50);
                    columnTemplate.maxHeight = 30;
                    columnTemplate.column.cornerRadius(60, 10, 60, 10);
                    columnTemplate.strokeOpacity = 0;

                    series.heatRules.push({
                        target: columnTemplate,
                        property: "fill",
                        dataField: "valueX",
                        min: am4core.color("#e5dc36"),
                        max: am4core.color("#5faa46")
                    });
                    series.mainContainer.mask = undefined;

                    var cursor = new am4charts.XYCursor();
                    chart.cursor = cursor;
                    cursor.lineX.disabled = true;
                    cursor.lineY.disabled = true;
                    cursor.behavior = "none";

                    var bullet = columnTemplate.createChild(am4charts.CircleBullet);
                    bullet.circle.radius = 10;
                    bullet.valign = "middle";
                    bullet.align = "left";
                    bullet.isMeasured = true;
                    bullet.interactionsEnabled = false;
                    bullet.horizontalCenter = "right";
                    bullet.interactionsEnabled = false;
                    var hoverState = bullet.states.create("hover");
                    var outlineCircle = bullet.createChild(am4core.Circle);
                    outlineCircle.adapter.add("radius", function (radius, target) {
                        var circleBullet = target.parent;
                        return circleBullet.circle.pixelRadius + 10;
                    })

                    var image = bullet.createChild(am4core.Image);
                    image.width = 30;
                    image.height = 30;
                    image.horizontalCenter = "middle";
                    image.verticalCenter = "middle";
                    image.propertyFields.href = "href";

                    image.adapter.add("mask", function (mask, target) {
                        var circleBullet = target.parent;
                        return circleBullet.circle;
                    })


                    var previousBullet;
                    chart.cursor.events.on("cursorpositionchanged", function (event) {
                        var dataItem = series.tooltipDataItem;

                        if (dataItem.column) {
                            var bullet = dataItem.column.children.getIndex(1);

                            if (previousBullet && previousBullet != bullet) {
                                previousBullet.isHover = false;
                            }

                            if (previousBullet != bullet) {

                                var hs = bullet.states.getKey("hover");
                                hs.properties.dx = dataItem.column.pixelWidth;
                                bullet.isHover = true;

                                previousBullet = bullet;
                            }
                        }
                    })
                }, 1000);
            },
            //Api call to get the load leads data
            async loadLeadsData() {
                try {
                    this.loadLeadsSection = true;
                    /**params = period, @prams = between*/
                    let params = {
                        period: this.time_period,
                        between: this.between
                    }
                    let response = await this.getLeadAnalyticsData(params)
                    let arr = []
                    arr = response.response
                    this.leads_data = arr
                    delete arr['contact_percentage'];
                    delete arr['customer_percentage'];
                    delete arr['qualified_percentage'];
                    delete arr['unqualified_percentage'];
                    let result = []
                    for (let x in this.leads_data) {
                        let data = x
                        if (x == 'total') {
                            x = "Total Leads"
                        }
                        if (x == 'contact') {
                            x = "Contact"
                        }
                        if (x == 'customer') {
                            x = "Customer"
                        }
                        if (x == 'qualified') {
                            x = "Qualified"
                        }
                        if (x == 'unqualified') {
                            x = "UnQualified"
                        }
                        result.push({
                            category: x,
                            value: this.leads_data[data]
                        });
                    };
                    this.leads_count = [Object.values(result)[0].value];
                    this.leads_data = result

                } catch (reason) {
                    this.loadLeadsSection = false;
                }
                if (this.leads_count == 0) {
                    this.loadLeadsSection = false;
                    setTimeout(() => {
                        var style = document.createElement('style');
                        style.type = 'text/css';
                        style.innerHTML =
                            '.leadCss {width: 130px!important;height: 100px!important;margin:auto!important;margin-top:20px !important;}';
                        document.getElementsByTagName('head')[0].appendChild(style);
                        document.getElementById('leadsDiv').innerHTML =
                            "<div class=text-center text-muted fw-500><img id= data-img src=/static/images/leads.png class=mt-3><div class= 'mt-4 text-muted fw-500'>No leads added!</div></div>";
                        document.getElementById('data-img').className = 'leadCss';
                    }, 1000);
                } else {
                    this.loadLeadsSection = false;
                    this.showLeadData()
                }
                this.loadLeadsSection = false;
            },
            //Show the leads resposne into the chart
            showLeadData() {
                setTimeout(() => {
                    let vueThis = this
                    var chart = am4core.create("leadsDiv", am4charts.PieChart);
                    // Add data
                    chart.data = vueThis.leads_data
                    // Add and configure Series
                    var pieSeries = chart.series.push(new am4charts.PieSeries());
                    pieSeries.dataFields.value = "value";

                    pieSeries.dataFields.category = "category";
                    pieSeries.innerRadius = am4core.percent(50);
                    pieSeries.ticks.template.disabled = true;
                    pieSeries.labels.template.disabled = true;
                    var rgm = new am4core.LinearGradientModifier();
                    rgm.brightnesses.push(0, -0.4);
                    pieSeries.slices.template.fillModifier = rgm;

                    var rgm2 = new am4core.LinearGradientModifier();
                    rgm2.brightnesses.push(0, -0.4);

                    pieSeries.slices.template.strokeModifier = rgm2;
                    pieSeries.slices.template.strokeOpacity = 1;
                    pieSeries.slices.template.strokeWidth = 1;

                    chart.legend = new am4charts.Legend();
                    chart.legend.position = "right";
                    chart.legend.align = "center";
                    chart.legend.contentAlign = "center"
                    chart.legend.valign = "center";
                    chart.legend.useDefaultMarker = true;

                    var label = pieSeries.createChild(am4core.Label);
                    label.text = vueThis.leads_count;

                    label.horizontalCenter = "middle";
                    label.verticalCenter = "middle";
                    label.fontSize = 15;

                    var marker = chart.legend.markers.template.children.getIndex(0);
                    marker.cornerRadius(12, 12, 12, 12);
                    marker.strokeWidth = 2;
                    marker.strokeOpacity = 1;
                    marker.stroke = am4core.color("#ccc");

                    var markerTemplate = chart.legend.markers.template;
                    markerTemplate.width = 4;
                    markerTemplate.height = 4;

                    pieSeries.slices.template.events.on("validated", function (event) {
                        var gradient = event.target.fillModifier.gradient
                        gradient.rotation = event.target.middleAngle + 90;

                        var gradient2 = event.target.strokeModifier.gradient
                        gradient2.rotation = event.target.middleAngle + 90;
                    })
                }, 1000);
            },
            //Api data to get the terriotry details
            async loadTerritoryDetails() {
                this.loadTerritorySalesSection = true;
                /**@prams = period, @prams = between */
                try {
                    let params = {
                        period: this.time_period,
                        between: this.between
                    }
                    let response = await this.getTerritorySalesData(params)
                    this.territory_data = response.response
                    this.loadTerritorySalesSection = false;
                } catch (error) {
                    this.loadTerritorySalesSection = false;
                }
            },
            //Api data to get the lead distribution
            async loadLeadDistribution() {
                 /**@prams = period, @prams = between */
                 this.loaddistributionSection = true;
                let params = {
                    period: this.time_period,
                    between: this.between
                }
                let response = await this.getCustomerDistribution(params)
                let customer_result = []
                let x = []
                this.customer_data = response.response
                for (x of this.customer_data) {
                    if (x.country == 'India') {
                        x.latitude = 20.5937,
                            x.longitude = 78.9629
                    }
                    if (x.country == 'Thailand') {
                        x.latitude = 15.8700,
                            x.longitude = 100.9925
                    }
                    customer_result.push({
                        name: x.country,
                        customer_name: x.customer_name,
                        latitude: x.latitude,
                        longitude: x.longitude,
                        hcenter: "left",
                        vcenter: "middle"
                    });
                }
                this.customer_data = customer_result
                this.loaddistributionSection = false;
                this.loadTerritoryData()
            },
            //get the repsonse of the territory data and set it into the graph
            loadTerritoryData() {
                setTimeout(() => {
                    let vueThis = this
                    // Create chart instance
                    var chart = am4core.create("territoryDiv", am4maps.MapChart);
                    am4core.useTheme(am4themes_animated);
                    chart.hiddenState.properties.opacity = 0; // this creates initial fade-in
                    chart.geodata = am4geodata_worldLow;
                    chart.projection = new am4maps.projections.Miller();
                    var polygonSeries = chart.series.push(new am4maps.MapPolygonSeries());
                    polygonSeries.useGeodata = true;
                    var polygonTemplate = polygonSeries.mapPolygons.template;
                    polygonTemplate.fill = am4core.color("#cce3fc");
                    // Exclude Antartica
                    polygonSeries.exclude = ["AQ"];
                    var placeSeries = chart.series.push(new am4maps.MapImageSeries());
                    var place = placeSeries.mapImages.template;
                    place.nonScaling = true;
                    place.propertyFields.latitude = "latitude";
                    place.propertyFields.longitude = "longitude";
                    place.propertyFields.value = "value";
                    placeSeries.data = vueThis.customer_data
                    var circle = place.createChild(am4core.Circle);
                    circle.radius = 4;
                    circle.fill = am4core.color("#e6ff00");
                    circle.stroke = am4core.color("#000");
                    circle.strokeWidth = 1;
                    var label = place.createChild(am4core.Label);
                    label.padding(10, 10, 10, 10);
                    label.propertyFields.text = "name";
                    label.propertyFields.horizontalCenter = "hcenter";
                    label.propertyFields.verticalCenter = "vcenter";
                    label.fill = am4core.color("#e6ff00");
                    label.stroke = am4core.color("#000");
                    label.strokeWidth = 1;
                    label.fontWeight = 800;
                }, 1000);
            },
            async loadCampaign() {
                this.loadCampaignInfoSection = true;
                try {
                    let params = {
                        range: this.created_report_date
                    }
                    let response = await this.getCustomerCampaignData(params)
                    this.revenue_generated_data = response.response.timing
                    this.total_budget = response.response.total_budget
                    const result = []
                    const map = new Map();
                    for (const item of this.revenue_generated_data) {
                        map.set(item.budget, true);
                        result.push({
                            date: item.period || '',
                            value: item.budget
                        });
                    }
                    this.graph_scale = response.response.graph_scale
                    const scale = []
                    for (const scaledata of this.graph_scale) {
                        scale.push(scaledata)
                    }
                    this.graph_scale = scale
                    this.revenue_generated_data = result
                    if (this.graph_scale == '') {
                        this.loadCampaignInfoSection = false;
                        setTimeout(() => {
                            var style = document.createElement('style');
                            style.type = 'text/css';
                            style.innerHTML =
                                '.imgCampCss {width:50%!important;height: 50%!important;margin: auto!important;margin-top:0px !important }';
                            document.getElementsByTagName('head')[0].appendChild(style);
                            document.getElementById('campaignsDiv').innerHTML =
                                "<div class=text-center><img id= convention-img src=/static/images/response.png class=mt-3><div class='mt-4 text-muted fw-500'>No amount added!</div></div></div>";
                            document.getElementById('convention-img').className = 'imgCampCss';
                        }, 1000);
                    } else {
                        this.loadCampaignInfoSection = false;
                        this.loadCampaignsCountData()
                    }
                    this.loadCampaignInfoSection = false;
                } catch (reason) {
                    this.loadCampaignInfoSection = false;
                }
            },
            //Api call to get the campangin count dataexpandData
            loadCampaignsCountData() {
                setTimeout(() => {
                    let vueThis = this;
                    am4core.useTheme(am4themes_animated);
                    var chart = am4core.create("campaignsDiv", am4charts.XYChart);
                    chart.paddingRight = 40;
                    var data = [];
                    var value = 50;
                    for (let i = -3650; i < 0; i++) {
                        let date = new Date();
                        date.setHours(0, 0, 0, 0);
                        date.setDate(i);
                        value -= Math.round((Math.random() < 0.5 ? 1 : -1) * Math.random() * 10);
                        if (value < 0) {
                            value = Math.round(Math.random() * 10);
                        }
                        data.push({
                            date: date,
                            value: value
                        });
                    }
                    chart.data = this.revenue_generated_data;
                    // Create axes
                    var dateAxis = chart.xAxes.push(new am4charts.DateAxis());
                    dateAxis.renderer.minGridDistance = 60;
                    dateAxis.groupData = true;
                    dateAxis.title.text = "Time"
                    dateAxis.title.fontWeight = 600;
                    var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
                    valueAxis.title.text = "Reference Number";
                    valueAxis.title.fontWeight = 600;
                    valueAxis.numberFormatter.numberFormat = "#a";
                    //create label
                    var ylabel = valueAxis.renderer.labels.template;
                    ylabel.truncate = true;
                    ylabel.maxWidth = 80;
                    ylabel.tooltipText = "{value}";
                    // Create series
                    var series = chart.series.push(new am4charts.ColumnSeries());
                    series.dataFields.valueY = "value";
                    series.dataFields.dateX = "date";
                    series.tooltipText = "{value}"
                    series.tooltip.pointerOrientation = "vertical";
                    chart.cursor = new am4charts.XYCursor();
                    chart.scrollbarX = new am4core.Scrollbar();
                }, 1000);
            },

        },
        watch: {
            selected_type: function () {
                this.loadMeetingData();
            },
            selected_calendar_month: function () {
                this.loadMeetingData();
            },
        },
        computed: {
            loggedInUser() {
                return this.$store.state.loggedInUser;
            },
            userPermissions() {
                return this.$store.getters.userPermissions;
            },
            attributes() {
                return [
                    // Attributes for todos
                    {
                        key: 'today',
                        highlight: {
                            color: 'blue',
                        },
                        dates: new Date(),
                    },
                    ...this.todos.map(todo => ({

                        dates: todo.date,
                        dot: {
                            color: 'red',
                        },
                        popover: {
                            visibility: 'hover',
                            placement: 'right',
                            hideIndicator: 'true',
                        },
                        customData: todo,
                    })),
                ];
            },
        },
        mounted() {
            this.ajaxCallInProgress = true;
            this.currency = this.loggedInUser.currency.symbol;
            setTimeout(() => {
                this.dateSettings();
                this.getCallReportType(),
                    this.loadDealsAnalytics(),
                    this.loadTargetAchieved(),
                    this.loadOverallSalesData(),
                    this.loadTerritoryDetails(),
                    this.loadLeadDistribution(),
                    this.loadContractsData(),
                    this.loadForecastAnalytics(),
                    this.loadLeadsData(),
                    this.loadContactMedia(),
                    this.loadCampaign(),
                    this.loadMeetingData(),
                    this.$nextTick(function () {
                        window.addEventListener('resize',
                            $(document).ready(function () {
                                setTimeout(() => {
                                    $('ul.menuScroll.flexScroll').flexMenu();
                                }, 1000);
                            })
                        );
                    });
                (function () {
                    $(function () {
                        $('.period-dropdown > a').on('click', function (e) {
                            var submenu;
                            submenu = $(this);
                            $('.period-dropdown .period-dropdown-menu').removeClass('show');
                            submenu.next('.period-dropdown-menu').addClass('show');
                            e.stopPropagation();
                        });
                        return $('.perioddropdown').on('hidden.bs.dropdown', function () {
                            // hide any open menus when parent closes
                            $('.period-dropdown-menu.show').removeClass('show');
                        });
                    });
                }).call(this);
                this.ajaxCallInProgress = false;
            }, 2000);
        }
    }
</script>
<style scoped>
    .secondary-email-list {
        display: flex;
        flex-direction: row;
        flex-flow: wrap;
    }

    .secondary-email {
        padding: 3.5px 19px 3.5px 7.5px;
        border-radius: 5px;
        background-color: rgba(197, 223, 253, 0.28);
        white-space: nowrap;
        margin: 5px;
    }

    .dropdown-callreport {
        position: absolute;
        top: 200px !important;
        left: 930px !important;
        transform-origin: center bottom;
        z-index: 2032;
    }

    .cards-text {
        align-items: center;
        justify-content: center;
        text-align: center;
    }

    .team-image {
        color: #fff;
        font-weight: 500;
        font-size: 12px;
        background: #F6923E;
        border-radius: 50%;
        width: 23px;
        height: 23px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .team-image-completed {
        background: #3A8025 !important
    }

    .meeting_dropdown {
        border: 1px solid transparent;
        border-bottom: 1px solid black;
        width: 100px;
    }

    .btn-done {
        background-color: #1D8A63;
        color: #fff;
        border-radius: 5px;
    }

    .btn-later {
        background-color: #F6923E;
        color: #fff;
        border-radius: 5px;
    }

    .text-meeting {
        color: #be0a94 !important
    }

    .text-sch-meet {
        color: #be4e0a !important
    }

    .text-flw-up {
        color: #3a8007 !important
    }

    .text-remind {
        color: #00448b !important
    }

    .type-event {
        background-color: #00448b !important;
        width: 13px;
        height: 13px;
    }

    .type-task {
        background-color: #be4e1b !important;
        width: 13px;
        height: 13px;
    }

    .type-meeting {
        background-color: #be0a94 !important;
        width: 13px;
        height: 13px;
    }

    .type-follow {
        background-color: #6774d5 !important;
        width: 13px;
        height: 13px;
    }

    .call-details {
        border: 1px solid #00448b;
        border-radius: 4px;
    }

    .invitee-details {
        /* border: 1px solid #000;
        border-radius: 4px; */
        padding: 4px 5px;
        max-height: 155px;
        overflow-x: scroll !important;
    }

    .desc-details {
        /* border: 1px solid #000;
        border-radius: 4px; */
        padding: 4px 5px;
        height: 70px;
        max-height: 70px;
        overflow-x: scroll !important;
    }

    .text-css {
        word-wrap: break-word !important
    }

    .active:hover {
        background-color: #00448b;
        color: #fff;
        pointer-events: cursor
    }

    .text-name-ellipsis {
        text-overflow: ellipsis;
        overflow: hidden;
        max-width: 150px;
        width: 150px;
        white-space: nowrap;
    }
    .title-name{
        max-width: 600px;
        width: 600px;
        word-break: break-all;
    }
    .card-div-height {
        height: 386px;
        max-height: 386px;
        overflow: scroll !important;
    }

    .hello {
        width: 100%;
        height: 500px;
    }

    .card-item {
        padding: 18px 18px 30px 37px;
        border-radius: 6px;
    }

    .card-item-contact {
        padding: 18px;
        border-radius: 6px;
    }

    .menuScroll {
        background: #fff !important;
        border: 1px solid #000;
        color: #000 !important;
    }

    .ml-32px {
        margin-left: 32px;
    }

    #leadsDiv {
        width: 100%;
        height: 200px;
    }

    #dealsDiv {
        width: 100%;
        height: 200px;
    }

    #territoryDiv {
        width: 100%;
        height: 200px;
        background-image: linear-gradient(to bottom, #003e96, #001f4b);
    }

    #contractDiv {
        width: 100%;
        height: 340px;
    }

    #campaignsDiv {
        width: 100%;
        height: 275px;
    }

    #targetDiv {
        width: 100%;
        height: 405px;
    }

    #forecastDiv {
        width: 100%;
        height: 430px;
    }

    .logo-image {
        width: 40px;
        height: 55px;
    }

    .contracts-logo {
        position: relative;
        bottom: 20px;
    }

    .pb-10px {
        padding-bottom: 10px;
    }

    .ongoing-survey-logo-image {
        width: 40px;
        height: 55px;
    }

    .meetings {
        border: 1px solid #00448b;
        border-radius: 4px;
        padding-top: 8px;
    }

    #salesForecastDiv {
        width: 100%;
        height: 412px;
    }

    #salesValue {
        width: 100%;
        height: 430px;
    }

    .table-properties {
        border-collapse: collapse;
        width: 100%;
    }

    table thead th {
        padding: 10px;
    }

    table.table-properties tbody td {
        padding: 8px 10px !important;
    }

    #days {
        cursor: not-allowed;
    }

    .expand-img {
        width: 22px;
        margin-bottom: 2px;
    }

    .today-meetings {
        min-height: 460px;
        max-height: 460px;
        overflow: scroll;
    }

    .icon-images {
        width: 24px;
        padding-right: 10px;
    }

    .copy-icon-images {
        width: 30px;
    }

    .mediaDiv {
        border: 1px solid #6491cb;
        border-radius: 2px;
        height: 185px;
        min-height: 180px;
        max-height: 180px;
        overflow: scroll;
    }

    .icon_div {
        background-color: #ffe1dd;
        border: 1px solid #ccc;
        color: #ef1747;

    }

    .icon_div_green {
        background-color: #cce8e0;
        border: 1px solid #ccc;
        color: #008a63;
    }

    .red-div {
        content: url("/static/images/images-new-theme/icons/sort-down-red.svg");
    }

    .green-div {
        content: url("/static/images/images-new-theme/icons/sort-up-green.svg");
    }

    .contactMedia {
        width: 100%;
        height: 270px !important;
    }

    .div-spacing {
        padding-right: 8px;
        padding-left: 8px;
    }

    ul {
        list-style-type: none !important;
    }

    .box-radius {
        border-radius: 7px !important;
    }

    .head-css {
        border-radius: 7px;
        border: 1px solid #00448b;
    }

    .dropdown-button {
        background-color: #fff !important;
        height: 30px;
        border-radius: 8px;
        font-size: 14px;
        font-weight: 500;
        padding: 0 1.5rem;
    }

    .on-focus:focus {
        outline: 1px solid #00448b;
    }

    .dropdown-toggle::after {
        font-size: 20px;
    }

    .dropdown-button span {
        color: #000;
        font-weight: 400;
    }

    .dropdown-submenu {
        position: relative;
        padding: 0;
    }

    .dropdown-item-toggle {
        margin-right: 5px;
    }

    .dropdown-item-toggle::after {
        position: absolute;
        right: 7px;
        content: '▸';
        color: #aaa;
        margin-left: 0.5rem;
    }

    .dropdown-menu {
        top: 4px !important;
        left: 10px !important;
        margin-top: -1px;
        border-radius: 8px;
    }

    .cust-dropdown-menu {
        left: -18px !important;
    }

    .sub-dropdown {
        left: -80% !important;
        width: 78%;
        margin: 0px;
        padding: 0px;
    }

    .dropdown-label {
        font-size: 16px;
        font-weight: 400;
        margin-right: 8px;
    }

    .leadsDiv-expand,
    .territoryDiv-expand,
    .dealsDiv-expand,
    .forecastDiv-expand,
    .salesForecastDiv-expand,
    .salesValue-expand {
        width: 100%;
        height: 600px !important;
        margin: auto;
        vertical-align: middle;
        line-height: 90
    }

    .text-ellipsis-table {
        text-overflow: ellipsis;
        overflow: hidden;
        max-width: 160px;
        width: 160px;
        display: block;
    }

    .disableButtons.fullscreen .btnpointer {
        cursor: not-allowed !important;
        display: none;
    }

    .disable-state {
        pointer-events: none;
        cursor: not-allowed !important;
    }

    .not-allow-state {
        cursor: not-allowed !important;
    }

    .call-sch {
        cursor: pointer;
    }

    .meeting-calendar .vc-container {
        border: none;
    }

    .type-select {
        border: 1px solid #000;
        border-radius: 4px;
    }

    .btn-new-white {
        color: #000;
        background-color: #fff;
        border-bottom: 1px solid #000;
        border-radius: 0px !important;
        text-transform: capitalize !important;
        height: 34px !important;
    }

    .btn-new-white:focus {
        border: 1px solid #5587C7;
        border-radius: 6px !important;
    }
    .btn-light.btnLight {
        border: 1px solid #5587C7 !important;
        text-transform: capitalize !important;
        background-color: #FFF !important;
    }
    .btn-light.btnLight:hover {
        color: #212529 !important;
        background-color: #e1e7ee6b !important;
        border-color: #5587C7 !important;
    }
    .bg-blue {
        color: #fff;
        background-color: #00448b !important;
        border-radius: 5px;
        height: 40px;
    }
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/SalesDashboard.vue